import { BCMSDate, DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import { TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView, WidgetContainer, WidgetView } from 'components/shared';
import { NoEntriesTableRow } from 'components/shared/views/TableView/components/NoEntriesTableRow';
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function CurrentAlertsWidget
 * @return {React.Component}
 * @exported true
 * @description The widget that shows the current alerts table
 */

export default function CurrentAlertsWidget(props){
  const { data } = useStateManager();
  const widgetID = "currentAlertsWidget";
  const alerts = data[widgetID].alerts;
  const hasAlerts = alerts.length > 0;
  const alertRows = alerts.reduce((acc, item, index) => {
    item.hours = 8;
    item.minutes = 10 + index;
    item.seconds = 11 + index;
    if(item.id !== undefined) acc.push(<CurrentAlertsTableRow dataPoint={ `Current_Alerts_Widget` } key={ item.id } alert={ item }/>);
    return acc;
  }, []);
  
  return(
    <WidgetContainer className="current-alerts-widget">
      <WidgetView dataPoint={ `Current_Alerts_Widget_Title` } text="Current Alerts">
        <TableView className="current-alerts-table">
          <TableColumnContainer>
            <TableColumnView text="Description" />
            <TableColumnView text="Created Date" />
            <TableColumnView text="" />
          </TableColumnContainer>
          { hasAlerts && alertRows }
          { !hasAlerts && <NoEntriesTableRow colSpan="2" text="There are no subscriptions." /> }
        </TableView>
      </WidgetView>
    </WidgetContainer>
  );
}

/**
 * @function CurrentAlertsTableRow
 * @return {React.Component}
 * @exported false
 * @description description
 */

function CurrentAlertsTableRow(props){
  const alert = props.alert ?? {};
  const dataPoint = props.dataPoint ?? "";
  const createdDate = `${ BCMSDate.init(alert.createdDateOffset).format("m/d/Y") }
  ${ alert.hours }:${ alert.minutes }:${ alert.seconds } AM`;
  const description = `Notify me when the ${ alert.alertMeWhen } on ${ alert.account.number } 
  is ${ alert.alertMeWhenBalanceIs } ${ alert.balanceThresholdAmount.format() }.`
  
  return(
    <TableItemContainer className="current-alerts-table-row">
      <TableItemTextView dataPoint={ `${ dataPoint }_Table_Row_Description_${ alert.id ?? "" }` } text={ description } />
      <TableItemTextView text={ createdDate } />
      <TableItemView>
        <div className="flex-container flex-horizontal align-center">
          <DisabledPrompt>
            <SVGAsset id="PencilIcon" className="edit-icon clickable" />
          </DisabledPrompt>
          <DisabledPrompt>
            <SVGAsset id="TrashcanXIcon" className="clickable" />
          </DisabledPrompt>
        </div>
      </TableItemView>
    </TableItemContainer>
  );
}